import React from 'react'
import './kovin.css';


function DrKusumRathnayake() {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">National</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/kusum.png" alt="Dr. Kusum Rathnayake" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Dr. Kusum Rathnayake</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
            Dr.  Kusum Ratnayake is immediate past President of the College of Ophthalmologists of Sri Lanka. Additionally he is the Cornea and External Eye Disease Specialist at the National Eye Hospital, Colombo. He also serves as the  Medical Director and (acting)chief executive Director of the National Eye Bank of Sri Lanka. Furthermore, he is  appointed as a trainer in the Cornea and External Eye Disease subspecialty and an examiner at the Postgraduate Institute of Medicine, University of Colombo.
              <br /><br />
He completed his post-MD general ophthalmology training at the “Center for Sight” in Teaching Hospital, Kandy and He later pursued subspecialty fellowship training in Cornea and External Eye Diseases and once he completed the local training , he trained at Apollo Hospitals in Hyderabad, India, under Dr. Rajesh Fogla, Senior Consultant Cornea and Refractive Surgeon, where he completed his fellowship in Cornea and External Eye Diseases.
In addition to his credentials as a Cornea and External Eye Disease Specialist, Dr. Kusum Ratnayake holds a fellowship in Refractive Surgery from Apollo Hospitals, Hyderabad. 
              <br /><br />
Upon returning to Sri Lanka, he was appointed as a Cornea and External Eye Disease Specialist at the National Eye Hospital in 2013
              <br /><br />
Dr. Kusum Ratnayake has published several articles in local and international journals and has contributed numerous research reports. In 2018, he earned a diploma from the APAO Leadership Development Program. He has been an invited speaker at various international conferences and annual academic programs organized by the College of Ophthalmologists of Sri Lanka
              <br /><br />  
              Dr. Kusum Ratnayake specializes in lamellar corneal surgery, refractive surgery and management of keratoconus, and ocular surface reconstruction. His clinical expertise encompasses advanced techniques Lamellar Corneal Surgery and customized refractive procedures aimed at enhancing visual outcomes while preserving corneal integrity. Committed to integrating cutting-edge technologies into his practice, Dr. Kusum Ratnayake continually adopts innovative methods to elevate patient care and achieve optimal surgical results.
              
            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
           <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default DrKusumRathnayake